import { useCallback, useEffect, useState } from 'react'
import { api, ApiError } from './lib/api.js'
import { Login } from './telas/Login.jsx'
import { Editor } from './telas/Editor.jsx'
import { Historico } from './telas/Historico.jsx'
import { Admin } from './telas/Admin.jsx'

export function App() {
  const [sessao, setSessao] = useState({ situacao: 'carregando' })

  const carregarSessao = useCallback(async () => {
    try {
      const usuario = await api.get('/me')
      setSessao({ situacao: 'autenticado', usuario })
    } catch (falha) {
      if (falha instanceof ApiError && falha.status === 401) return setSessao({ situacao: 'anonimo' })
      setSessao({ situacao: 'erro', mensagem: falha.message })
    }
  }, [])

  useEffect(() => {
    carregarSessao()
  }, [carregarSessao])

  if (sessao.situacao === 'carregando') {
    return <main className="pagina"><p className="ajuda">Carregando…</p></main>
  }
  if (sessao.situacao === 'erro') {
    return <main className="pagina"><p className="alerta alerta--falha">{sessao.mensagem}</p></main>
  }
  if (sessao.situacao === 'anonimo') return <Login aoEntrar={carregarSessao} />

  return <Portal usuario={sessao.usuario} aoSair={() => setSessao({ situacao: 'anonimo' })} />
}

function Portal({ usuario, aoSair }) {
  const agentes = usuario.permissoes
  const [agente, setAgente] = useState(agentes[0]?.agente ?? null)
  const [aba, setAba] = useState('editor')

  const papel = agentes.find((a) => a.agente === agente)?.papel ?? 'leitor'
  const ehAdmin = agentes.some((a) => a.papel === 'admin')

  async function sair() {
    await api.post('/auth/sair').catch(() => {})
    aoSair()
  }

  if (!agente) {
    return (
      <main className="pagina">
        <p className="alerta alerta--falha">Seu usuário não tem acesso a nenhum agente.</p>
        <button className="botao" onClick={sair}>Sair</button>
      </main>
    )
  }

  return (
    <>
      <header className="topo">
        <div className="topo__marca">
          Portal IA <span className="topo__cliente">CMB</span>
        </div>

        <label className="campo campo--inline">
          <span>Agente</span>
          <select
            value={agente}
            onChange={(evento) => {
              setAgente(evento.target.value)
              setAba('editor')
            }}
          >
            {agentes.map((a) => (
              <option key={a.agente} value={a.agente}>
                {a.agente}
              </option>
            ))}
          </select>
        </label>

        <nav className="abas">
          <button className={aba === 'editor' ? 'aba aba--ativa' : 'aba'} onClick={() => setAba('editor')}>
            Editor
          </button>
          <button className={aba === 'historico' ? 'aba aba--ativa' : 'aba'} onClick={() => setAba('historico')}>
            Histórico
          </button>
          {ehAdmin && (
            <button className={aba === 'admin' ? 'aba aba--ativa' : 'aba'} onClick={() => setAba('admin')}>
              Admin
            </button>
          )}
        </nav>

        <div className="topo__usuario">
          <span className="ajuda">{usuario.email}</span>
          <button className="botao botao--discreto botao--pequeno" onClick={sair}>
            Sair
          </button>
        </div>
      </header>

      <main className="pagina">
        {/* key força remontar ao trocar de agente: nada de estado vazando entre agentes. */}
        {aba === 'editor' && <Editor key={agente} agente={agente} papel={papel} usuario={usuario} />}
        {aba === 'historico' && <Historico key={agente} agente={agente} papel={papel} usuario={usuario} />}
        {aba === 'admin' && ehAdmin && <Admin agentesDoUsuario={agentes} usuario={usuario} />}
      </main>
    </>
  )
}
